import React from 'react';

const Loader = ({ size = "h-12 w-12", text = "Loading...", showText = true, fullScreen = false }) => {
  const containerClasses = fullScreen 
    ? "flex items-center justify-center min-h-screen p-5 bg-white min-w-screen"
    : "flex flex-col items-center justify-center py-8";

  return (
    <div className={containerClasses}>
      <div className={`animate-spin rounded-full border-4 border-dashed border-orange-500 ${size}`}></div>
      {showText && (
        <p className="text-gray-600 dark:text-gray-400 font-medium mt-4">{text}</p>
      )}
    </div>
  );
};

export default Loader;
